import {
  IFileVariantResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IFileVariantResponseInstance'

export interface IImageFileVariantSize {
  width: number
  height: number
}

function toSize(value: unknown): IImageFileVariantSize | null {
  const size = value as {width?: unknown, height?: unknown}
  if(typeof size?.width !== 'number' || typeof size?.height !== 'number') {
    return null
  }
  if(size.width <= 0 || size.height <= 0) {
    return null
  }
  return {
    width: size.width,
    height: size.height,
  }
}

export function getImageFileVariantSize(fileVariant: IFileVariantResponseInstance): IImageFileVariantSize | null {
  return toSize(fileVariant?.meta) || toSize(fileVariant?.payload)
}
